<template>
  <Container
    class="mx-auto mt-10 gap-5 md:mt-25 md:gap-7.5 xl:mt-30! xl:gap-10 2xl:mt-35! 2xl:gap-11.5"
  >
    <SectionTitle
      :title="sectionData.title"
      :link="sectionData.url"
      :target="sectionData.target"
    />
    <CardSlider :slides="eventsData" />
  </Container>
</template>

<script setup lang="ts">
import type { AppEvent, HomepageSection } from '~/types'

interface Props {
  sectionData: HomepageSection<AppEvent>
}

const props = defineProps<Props>()

const eventsData = computed(() => props.sectionData?.items)
</script>
